import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const FETCH_PREVIOUS_MESSAGE_HISTORY = createAsyncActionTypes('FETCH_PREVIOUS_MESSAGE_HISTORY');